import React from "react";
import Layout from "./Layout";
import Authenticator from "./Authenticator";
import MaintenanceRedirector from "./MaintenanceRedirector";
import { useAppContext } from "../context/app";

interface AppRootProps {
  children: React.ReactNode;
}

const AppRoot = ({ children }: AppRootProps) => {
  const { isSignedIn } = useAppContext();

  if (isSignedIn === null) {
    return <div></div>;
  }

  return isSignedIn ? (
    <MaintenanceRedirector>
      <Layout>{children}</Layout>
    </MaintenanceRedirector>
  ) : (
    <Authenticator />
  );
};

export default AppRoot;
